var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-project-header"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('activity.log'))+" ")]),_c('v-btn',{staticClass:"new-project-button",attrs:{"color":"primary"},on:{"click":_vm.newProjectClicked}},[_vm._v(" "+_vm._s(_vm.$t('projectsList.header.create.project'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }